export default __webpack_public_path__ + "static/media/edital52024local.fbe573f7.pdf";